<!--
TODO
  - when saved then PUT should be implemented not saving the new one
  - add the correct identifier to the widget on install button
-->


<template>
  <div class="full-screen-layout relative">
    <div
      v-if="!loadingWidget"
      class="header flex flex-align-center SB-border bottom">
      <h1
        class="mr-3 flex flex-align-center" >
        <div
          class="back-btn flex flex-align-center"
          @click="goBack('WebWidgets')" >
          <SBIcon
            class="mr-2"
            :icon="SBIconList.DOWN_ARROW"
            :color="SBColors.greyPrimary"
            :size="12"
            :rotate="90" />
          <p class="mr-3">{{ isEditMode ? 'Edit web widget' : 'Create new web widget' }}</p>
        </div>
      </h1>
      <span class="greedy" />
      <b-button
        id="clear-btn"
        class="flex center-all"
        :disabled="disabled"
        @click="resetTesting()" >
        <SBIcon
          class="mr-2"
          :icon="SBIconList.PLAY"
          :color="SBColors.blackPrimary"
          :size="11"/>
        <span>View animation</span>
      </b-button>
      <p
        class="toggle-label ml-4 mr-2 no-shrink"
        :class="{ live: widgetState }">{{ widgetState ? 'Widget is active' : 'Widget is disabled' }}</p>
      <SwitchCheckbox
        v-model="widgetState"
        size="medium no-shrink"
        class="no-label-margin mr-2"
        :off-outline-color="SBColors.blackUltralight"
        :value="true"
        @click.native.stop
        @input="toggleWidget" />
    </div>
    <Spinner
      v-if="loadingWidget"
      class="full-width cover mask-spinner"
      :size="20"
      :thickness="2" />
    <div
      v-else
      id="playground-wrapper"
      class="flex greedy" >
      <div
        id="widget-editor"
        class="relative SB-border right no-shrink">
        <div class="flex column h-100">
          <div
            class="o-auto greedy"
            style="height: 0;">
            <FormBlock
              ref="formBlockRef"
              v-model="formValue"
              :form-schema="widgetFormSchema"
              title="Customize your web widget"
              description="Personalize and embed this web widget on your website in minutes."
              @info="handleFormInfo" />
          </div>
          <div class="footer SB-border top flex flex-align-center">
            <b-button
              v-if="!formInfo.hasChanges && isEditMode"
              variant="success"
              class="flex center-all"
              @click="installWidget">
              <SBIcon
                class="mr-1"
                :icon="SBIconList.COG"
                color="#00bfa5"
                :size="12" />
              <span>Install widget</span>
            </b-button>
            <div class="greedy" />
            <b-button
              v-if="formInfo.hasChanges"
              :disabled="saving"
              class="flex"
              @click="resetForm">
              <span>Cancel</span>
            </b-button>
            <b-button
              variant="primary"
              :disabled="!formInfo.hasChanges || !formInfo.valid"
              class="flex settings__actions--save"
              :class="{loading: saving}"
              style="margin-left: 10px;"
              @click="saveWidget">
              <span>{{ isEditMode ? 'Save' : 'Create widget' }}</span>
              <Spinner
                v-if="saving"
                :size="14"
                :thickness="2"
                :color="SBColors.white" />
            </b-button>
          </div>
        </div>
      </div>
      <div
        id="widget-playground"
        class="flex column greedy relative p-0" >
        <div
          class="body greedy" >
          <ScrollArea
            ref="messageScrollbar"
            class="messages-scroll-area"
            :top-offset="100"
          >
            <div id="skeleton" >
              <div
                class="flex flex-align-center SB-border bottom"
                style="padding: 15px 38px 11px;" >
                <Skeleton
                  width="31px"
                  height="31px"
                  :radius="50"
                  class="mr-3" />
                <Skeleton width="84px"/>
                <div class="greedy" />
                <Skeleton
                  width="41px"
                  :radius="50"
                  class="mr-3" />
              </div>
              <div
                class="flex column center-all"
                style="padding: 63px 38px 15px;">
                <Skeleton
                  width="50%"
                  :radius="14"
                  class=""
                  style="" />
                <Skeleton
                  width="27%"
                  :radius="14"
                  class=""
                  style="margin-top: 15px;" />
              </div>
              <div style="padding: 41px 38px 15px;">
                <Skeleton
                  width="100%"
                  height="296px"
                  :radius="14"
                  class="" />
              </div>
              <div
                class="flex column"
                style="padding: 63px 38px 15px; max-width: 60%; margin: 0 auto;">
                <div
                  class="flex space-between"
                  style="margin: 0 0 41px; " >
                  <Skeleton
                    width="45%"
                    :radius="14"
                    class="" />
                  <Skeleton
                    width="45%"
                    :radius="14"
                    class="" />
                </div>
                <Skeleton
                  width="100%"
                  height="133px"
                  :radius="14"
                  class="" />
                <div
                  class="flex space-between"
                  style="margin: 35px 0 0;" >
                  <Skeleton
                    width="45%"
                    height="101px"
                    :radius="14"
                    class="" />
                  <Skeleton
                    width="45%"
                    height="101px"
                    :radius="14"
                    class="" />
                </div>
                <div
                  class="flex space-between"
                  style="margin: 35px 0 0;" >
                  <Skeleton
                    width="45%"
                    height="101px"
                    :radius="14"
                    class="" />
                  <Skeleton
                    width="45%"
                    height="101px"
                    :radius="14"
                    class="" />
                </div>
                <div
                  class="flex space-between"
                  style="margin: 35px 0 0;" >
                  <Skeleton
                    width="45%"
                    height="101px"
                    :radius="14"
                    class="" />
                  <Skeleton
                    width="45%"
                    height="101px"
                    :radius="14"
                    class="" />
                </div>
              </div>
              <div
                style="padding: 30px 38px 15px;"
                class="flex column gap-10" >
                <Skeleton
                  width="90%"
                  :radius="14" />
                <Skeleton
                  width="100%"
                  :radius="14" />
                <Skeleton
                  width="78%"
                  :radius="14" />
                <Skeleton
                  width="34%"
                  :radius="14" />
              </div>
              <div
                class="flex column center-all"
                style="padding: 63px 38px 50px;">
                <Skeleton
                  width="50%"
                  :radius="14"
                  class=""
                  style="" />
                <Skeleton
                  width="28%"
                  :radius="14"
                  class=""
                  style="margin-top: 15px;" />
              </div>
              <div
                style="padding: 30px 38px 15px;"
                class="flex column gap-10" >
                <Skeleton
                  width="96%"
                  :radius="14" />
                <Skeleton
                  width="67%"
                  :radius="14" />
                <Skeleton
                  width="88%"
                  :radius="14" />
                <Skeleton
                  width="54%"
                  :radius="14" />
              </div>
              <div
                style="padding: 30px 38px 15px;"
                class="flex center-all gap-20" >
                <Skeleton
                  width="30px"
                  height="30px"
                  :radius="14" />
                <Skeleton
                  width="30px"
                  height="30px"
                  :radius="14" />
                <Skeleton
                  width="30px"
                  height="30px"
                  :radius="14" />
                <Skeleton
                  width="30px"
                  height="30px"
                  :radius="14" />
              </div>
            </div>
            <iframe
              id="iframe-preview"
              src="about:blank"
              title="Widget Preview" />
            <!-- <pre>{{ formValue }}</pre>
            <pre>{{ formInfo }}</pre> -->
          </ScrollArea>
        </div>
      </div>
    </div>

    <b-modal
      id="install-web-widget-modal"
      v-model="showInstallModal"
      title="Install web widget on your website"
      centered
      hide-header-close
      ok-only
      ok-variant="secondary"
      ok-title="Close"
      @ok="showInstallModal = false">
      <div class="flex column gap-23">
        <h3>Add this code inside your website's <span class="tag-markup">&lt;head&gt;</span>...<span class="tag-markup">&lt;head&gt;</span> section to install the widget.</h3>
        <div class="code-section" >{{ widgetCode }}</div>
        <b-button
          variant="primary"
          class="copy-me"
          @click="copyToClipboard" >
          Copy code
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { debounce } from 'debounce';

import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import ScrollArea from '@/components/common/ScrollArea';
import randomString from '@/helpers/randomString';
import CommonActions from '@/components/manage/CommonActions.mixin';
import api from '@/helpers/api';
import Spinner from '@/components/common/Spinner';
import ToasterMixin from '@/mixins/Toaster';
import SwitchCheckbox from '@/components/common/SwitchCheckbox';
import FormBlock from '@/components/forms_schema/FormBlock';
import Skeleton from '@/components/forms_schema/form_components/Skeleton';
import { populateEmptySchemaBase, createFormSchemaBodyFormat, populateFormBody } from '../forms_schema/formSchema.helpers';

export default {
  name: 'WebWidgetCreate',
  components: {
    SBIcon,
    ScrollArea,
    Spinner,
    SwitchCheckbox,
    FormBlock,
    Skeleton,
  },
  mixins: [
    CommonActions,
    ToasterMixin,
  ],
  data() {
    return {
      buttonLoader: false,
      formValue: {},
      widgetState: true,
      disabled: false,
      messages: [],
      clearing: false,
      postponedMessage: null,
      loadingWidget: true,
      formInfo: {},
      editMessages: {},
      initData: null,
      showInstallModal: false,
      widget: null,
      SBIconList,
      SBColors,
      preventNewEditMessage: null,
      saving: false,
      resetWidgetAnimation: false,
      overridenFormSchema: {},
      widgetInitialized: false,
      // Use this if the component needs to be reloaded when the updated assistant but try to avoid it because the component resets itself.
      assistantUpdatedCounter: 0,
      assistantDataSavedSystemMessageShown: false,
      toasterTypeMap: {
        error: 'error',
        warning: 'warning',
        success: 'OK',
      },
      sendMessageTimeout: null,
      currentStep: 0,
      resetStepper: false,
      widgetCode: '',
      widgetCodeTemplate_bkp: `
        <script>
          ((w, d, s, o, f, js, fjs) => {
            w['AiNumberWidget'] = o;
            w[o] =
              w[o] ||
              function () {
                (w[o].q = w[o].q || []).push(arguments);
              };
            (js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]);
            js.id = o;
            js.src = f;
            js.async = 1;
            fjs.parentNode.insertBefore(js, fjs);
          })(window, document, "script", "AINW", "https://widget.ainumber.com/v1/number-widget.umd.js?v=" + Date.now());
          AINW("w", WIDGET_ID);
        <\/script>`,
      widgetCodeTemplate: `
        <script>(function(w,d){var o='AINW';w.AiNumberWidget=o;w[o]=w[o]||function(){(w[o].q=w[o].q||[]).push(arguments);};if(!d.getElementById('ainw-loader')){var s=d.createElement('script');s.id='ainw-loader';s.async=true;s.src='https://widget.ainumber.com/v1/number-widget.umd.js?v='+Date.now();(d.head||d.documentElement).appendChild(s);}})(window,document);AINW('w',WIDGET_ID);<\/script>`,
    };
  },
  computed: {
    ...mapGetters({
      membersLookup: 'organisation/currentOrganisationMembersLookup',
      currentOrganisation: 'organisation/currentOrganisation',
      enableAICreateAndEdit: 'organisation/enableAICreateAndEdit',
    }),
    isEditMode() {
      return !!this.$route.params.widgetId;
    },
    widgetFormSchema() {
      if (!this.emptyObject(this.overridenFormSchema)) {
        return JSON.parse(JSON.stringify(this.overridenFormSchema));
      }
      return {
        type: 'object',
        properties: {
          name: {
            type: 'input',
            returnProperties: [
              'value',
            ],
            title: 'Widget name',
            placeholder: 'Support widget',
            validators: 'required|maxLength:100|checkDuplicate:organisation/webWidgets,https://app.dev.number.tm/w/organisation/a63e6863-1e61-457e-b286-a0a22ee67f7a/widgets,name,organisation/SET_WEB_WIDGETS',
          },
          business_name: {
            type: 'input',
            returnProperties: [
              'value',
            ],
            title: 'Business name',
            placeholder: 'Super company',
            validators: 'required|maxLength:100',
          },
          language: {
            value: 'en',
            type: 'dropdown',
            returnProperties: [
              'value',
            ],
            title: 'Language',
            placeholder: 'Select language',
            validators: 'required',
            options: [
              {
                value: 'hr',
                label: 'Croatian',
              },
              {
                value: 'nl',
                label: 'Dutch',
              },
              {
                value: 'en',
                label: 'English',
              },
              {
                value: 'fr',
                label: 'French',
              },
              {
                value: 'es',
                label: 'Spanish',
              },
              {
                value: 'srb',
                label: 'Serbian',
              },
            ],
          },
          position: {
            value: 'right',
            type: 'dropdown',
            returnProperties: [
              'value',
            ],
            title: 'Position',
            placeholder: 'Select widget position',
            validators: 'required',
            options: [
              {
                value: 'left',
                label: 'Left',
              },
              {
                value: 'right',
                label: 'Right',
              },
            ],
          },
          channels: {
            type: 'widgetSources',
            returnProperties: [
              'value',
            ],
            title: 'Buttons',
            hideOptional: true,
            addButtonText: 'Add button',
            maxButtons: 20,
            minButtons: 1,
            hoverDeleteButtons: false,
            defaultLocation: '🏢 Head Office',
            sourcesOptions: [
              {
                value: 'whatsapp',
                label: 'WhatsApp',
                validators: 'required|phone',
              },
              {
                value: 'call',
                label: 'Call',
                validators: 'required|phone',
              },
              {
                value: 'text',
                label: 'Text',
                validators: 'required|phone',
              },
              {
                value: 'email',
                label: 'Email',
                validators: 'required|email',
              },
              {
                value: 'messenger',
                label: 'Messenger',
                validators: 'required',
              },
            ],
            value: [],
          },
        },
      };
    },
    // TODO widget
    assistant() {
      const targetAssistant = this.aiAssistants && Array.isArray(this.aiAssistants) ? this.aiAssistants.find(assistant => assistant.uid === this.assistantId) : null;
      return targetAssistant || {};
    },
    editMessage() {
      let finalMessage = 'Save to apply changes';
      if (Object.keys(this.editMessages).length) {
        let editMessagesValues = Object.values(this.editMessages);
        if (Object.keys(this.editMessages).length > 1) {
          const tempEditMessagesObject = JSON.parse(JSON.stringify(this.editMessages));
          delete tempEditMessagesObject.default;
          editMessagesValues = Object.values(tempEditMessagesObject);
        }
        // let changes = editMessagesValues.shift();
        let changes = '';
        editMessagesValues.forEach((message, index) => {
          changes += editMessagesValues.length === index + 1 ? ' and ' : ', ';
          changes += message;
        });
        finalMessage += changes;
      }
      return `${finalMessage}.`;
    },
    organisationId() {
      return this.$route.params.organisationId;
    },
    widgetId() {
      return this.$route.params.widgetId;
    },
  },
  watch: {
    assistantDataSaved() {
      // console.log('ASSISTANT MADE CHANGES', this.assistantDataSaved);
      // Check if it is the right assistant because the toast is shown only if the change is on the assistant the user is trying to edit at the moment.
      if (!this.assistantDataSavedSystemMessageShown && this.assistantId === this.assistantDataSaved.assistantId) {
        const targetAssistant = this.aiAssistants && Array.isArray(this.aiAssistants) ? this.aiAssistants.find(assistant => assistant.uid === this.assistantId) : null;
        const data = {
          id: randomString(10),
          code: 'assistantDataSaved',
          action: 'restart',
          message: `Your teammate just updated <img style="height: 13px; position: relative; top: 1px;" src="${targetAssistant.avatar}" /> ${targetAssistant.name}.`,
        };
        this.showSystemMessage(data, null, null, { text: 'REFRESH FORM' }, '⚠️', true, this.refreshPlayground);
        this.assistantDataSavedSystemMessageShown = true;
      }
      // find assistant and add its namr to the toast - Skipp for now because memberId is not provided
      // this.showToaster(`<span class="emoji-fix">✏️</span> ${this.member.name} just updated the ${assistant.name}.`);
    },
    enableAICreateAndEdit: {
      handler() {
        if (!this.enableAICreateAndEdit) {
          this.loadingWidget = false;
        }
      },
      immediate: true,
    },
    formInfo: {
      handler() {
        // console.log('formInfo', this.formInfo);
      },
      deep: true,
    },
    formValue: {
      handler() {
        this.updateWidget();
      },
      deep: true,
    },
  },
  beforeDestroy() {
  },
  mounted() {
    if (this.isEditMode) {
      this.loadWidget();
    } else {
      this.loadingWidget = false;
      setTimeout(() => {
        this.setWidget();
      }, 0);
    }
    // window.eventBus.$on('wakeup', this.softReset);

    // Scroll the skeleton when message from iframe comes in
    window.addEventListener('message', (e) => {
      // if messages from widget are needed then make sure the origin is set to 'https://localhost:8080'
      // if (e.origin === 'https://localhost:8080') SOMECODE;

      if (e.data.type === 'scroll') {
        const el = this.$el.querySelector('#skeleton');
        el.scrollTop += e.data.deltaY;
      }
    });
  },
  methods: {
    ...mapActions({
      fetchAiAssistants: 'organisation/fetchAiAssistants',
      updateLocalAssistant: 'organisation/updateLocalAssistant',
      clearToggleElements: 'flows/clearToggleElements',
    }),
    handleFormInfo(info) {
      // console.log('handleFormInfo', info);
      this.formInfo = info;
    },
    // TODO ADD THE CORRECT IDENTIFIER
    installWidget() {
      this.widgetCode = this.widgetCodeTemplate.replace('WIDGET_ID', `'${this.widget.identifier}'`); // .replaceAll(/\s/g, '');
      this.showInstallModal = true;
    },
    loadWidget() {
      this.loadingWidget = true;
      api('GET', `/organisation/${this.currentOrganisation.id}/widgets/${this.widgetId}/detail`, null, null, 'w')
        .then((response) => {
          if (response.status === 200) {
            this.widgetState = response.data.is_active;
            this.widget = response.data;
            const nfs = populateEmptySchemaBase(this.widgetFormSchema, { ...this.widget.data, name: this.widget.name, channels: this.sourcesToFormSchemaChannels(this.widget.data.channels) });
            this.overridenFormSchema = nfs;
            this.loadingWidget = false;
            setTimeout(() => {
              this.setWidget();
            }, 0);
          } else {
            this.$router.replace({ name: 'WebWidgets' });
          }
        })
        .catch(() => {
          this.$router.replace({ name: 'WebWidgets' });
        });
    },
    copyToClipboard() {
      this.$clipboard(this.widgetCode);
      this.showToaster('Code has been successfully copied.', null, null, 'OK');
    },
    saveWidget() {
      if (this.saving) return;

      this.saving = true;
      const channels = this.proccessSources();

      const widgetBody = {
        name: this.formValue.name,
        is_active: this.widgetState,
        data: {
          position: this.formValue.position,
          language: this.formValue.language,
          business_name: this.formValue.business_name,
          channels,
        },
      };

      // console.log('BODY', widgetBody);

      if (this.formInfo.hasChanges && this.formInfo.valid) {
        let method = 'POST';
        let urlSuffix = 'create';
        if (this.isEditMode) {
          method = 'PUT';
          urlSuffix = `${this.widgetId}/update`;
        }
        api(method, `/organisation/${this.currentOrganisation.id}/widgets/${urlSuffix}`, widgetBody, null, 'w')
          .then((response) => {
            if (response.status === 200) {
              let action = 'edited';
              this.formInfo = {};
              // only show the install modal after the initial create of the widget
              if (!this.isEditMode) {
                this.widgetCode = this.widgetCodeTemplate.replace('WIDGET_ID', response.data.identifier);
                this.showInstallModal = true;
                this.$router.replace({ name: 'WebWidgetEdit', params: { widgetId: response.data.id } });
                action = 'created';
              }
              this.$set(this, 'widget', response.data);

              const nfs = populateEmptySchemaBase(this.widgetFormSchema, { ...this.formValue, name: widgetBody.name });
              this.overridenFormSchema = nfs;

              this.showToaster(`Web widget was successfully ${action}.`, null, null, 'OK');
            }
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },
    updateWidget: debounce(function f() {
      const channels = this.proccessSources();
      const iframe = document.getElementById('iframe-preview');
      if (iframe && iframe.contentWindow) {
        const body = {
          type: 'updateConfig',
          config: {
            position: this.formValue.position,
            language: this.formValue.language,
            business_name: this.formValue.business_name,
            widget_id: this.widget && this.widget.identifier ? `${this.widget.identifier}` : '',
            channels,
            temp: !this.widgetId || this.formInfo.hasChanges,
            editMode: this.isEditMode,
          },
        };

        if (!this.widgetInitialized) {
          body.config.open = true;
        }
        if (this.resetWidgetAnimation) {
          body.config.reset = true;
          this.resetWidgetAnimation = false;
        }

        iframe.contentWindow.postMessage(body, '*');

        this.widgetInitialized = true;
      }
    }, 500),
    toggleWidget() {
      this.widget.is_active = this.widgetState;
      const payload = { ...this.widget };
      delete payload.label;
      delete payload.active;
      delete payload.id;
      delete payload.identifier;
      delete payload.updated_at;
      delete payload.created_at;

      api('PUT', `/organisation/${this.currentOrganisation.id}/widgets/${this.widget.id}/update`, payload, null, 'w')
        .catch((error) => {
          this.widgetState = !this.widgetState;
          this.showToaster('Something went wrong. Please try again.', null, null, 'error');
        });
    },
    resetForm() {
      this.$refs.formBlockRef.resetForm();
    },

    setWidget() {
      const iframe = document.getElementById('iframe-preview');
      const doc = iframe.contentDocument || iframe.contentWindow.document;

      const widgetInitScript = `
        ((w, d, s, o, f, js, fjs) => {
          w['AiNumberWidget'] = o;
          w[o] =
            w[o] ||
            function () {
              (w[o].q = w[o].q || []).push(arguments);
            };
          (js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]);
          js.id = o;
          js.src = f;
          js.async = 1;
          fjs.parentNode.insertBefore(js, fjs);
        })(window, document, "script", "AINW", "https://widget.ainumber.com/v1/number-widget.umd.js?v=123");
        AINW("c", {
          open: true,
          position: "right",
          language: "en",
          business_name: "",
          channels: {
            whatsapp: [
              {
                contact: "+0123456789",
                label: "Office",
              },
            ],
          },
        });

        let emitScroll = true;
        window.addEventListener('wheel', (e) => {
          // console.log('WHEEL', e);
          if (emitScroll) {
            parent.postMessage({ type: 'scroll', deltaY: e.deltaY }, '*');
          }
        });
        window.addEventListener('mouseover', (e) => {
          // console.log('MOUSEOVER', e);
          if (e.target.tagName === 'AINUMBER-WIDGET') {
            // console.log('MOUSEOVER AINUMBER-WIDGET');
            emitScroll = false;
          } else {
            emitScroll = true;
          }
        });

        window.addEventListener('message', (e) => {
          if (e.data.type === 'updateConfig') {
            // console.log('GOT THE MESSAGE', e);
            AINW("c", e.data.config);
          }
        });
      `;

      const htmlContent = `
        <!DOCTYPE html>
        <html>
          <head><title>Dynamic Page</title></head>
          <body></body>
        </html>
      `;

      doc.open();
      doc.write(htmlContent);
      doc.close();

      const script = doc.createElement('script');
      script.text = widgetInitScript;
      doc.body.appendChild(script);
    },
    refreshPlayground() {
      this.clearFileChangeCounter();
      this.removeAllCounters();
      this.resetTempFileCounter(this.assistantId);
      this.loadingWidget = true;
      this.assistantsFormSchema = {};
      return this.getAssistantScheme();
    },
    getAssistantScheme(showSpinner = true) {
      this.loadingWidget = showSpinner;
      let endpoint = `organisation/${this.currentOrganisation.id}/assistant/${this.$route.params.assistantId}`;
      if (this.$route.params && this.$route.params.data) {
        endpoint = `organisation/${this.currentOrganisation.id}/assistant/empty-scheme`;
      }

      const response = api('GET', endpoint, null, null, 'w');
      response
        .then((response) => {
          // this.assistantsFormSchema = {};
          this.$nextTick(() => {
            if (this.$route.params && this.$route.params.data) {
              this.assistantsFormSchema = populateEmptySchema(response.data, this.initData);
            } else {
              this.assistantsFormSchema = response.data;
            }
            // this.assistantsFormSchema = { ...this.assistantsFormSchema };
          });
        })
        .catch((error) => {
          if (error.response.status === 403) {
            setTimeout(() => {
              // NOTE: this is used just for blocking the UI for a while until we enable this to all the users
              this.loadingWidget = false;
            }, 2000);
          }
        });
      return response;
    },
    closeTesting() {
      this.$router.push({
        name: 'WebWidgets',
      });
    },
    resetTesting() {
      this.resetWidgetAnimation = true;
      this.updateWidget();
    },
    showCreateAssistantError(error = null) {
      if (error && error.response && error.response.data && error.response.data.messages) {
        if (error.response.data.messages && Array.isArray(error.response.data.messages)) {
          error.response.data.messages.forEach((message) => {
            this.showToaster(message.message, null, null, this.toasterTypeMap[message.type]);
          });
        }
      } else {
        // const message = error && error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Something went wrong. Please try again.';
        this.showToaster('We couldn\'t update AI assistant.', null, null, 'error');
      }
    },
    updateAssistant(data) {
      this.updatingAssistant = true;
      this.$eventBus.$emit('setBlockingOverlay', true);
      // console.log('DATA', { ...data });
      const assistantsFormSchemaBodyFormat = createFormSchemaBodyFormat(this.assistantsFormSchema.scheme);
      // console.log('FORMAT');
      // console.log(assistantsFormSchemaBodyFormat);
      // return;
      const assistantsFormSchemaBodyPopulated = populateFormBody(assistantsFormSchemaBodyFormat, data);
      const body = { data: assistantsFormSchemaBodyPopulated, includeMe: false };

      // TESTING schema repopulation -----------------------------
      // console.log('BODY');
      // console.log(body);
      // this.testPopulatedSchema = populateEmptySchema(this.assistantsFormSchema, body);
      // this.assistantSelected({ uid: 'aee6a0a7-1a22-4ba0-b7cf-1e470503bb5' }, body);
      // return;
      // TESTING schema repopulation --- END --------------------------


      const postActions = this.checkPostActions(data);
      const url = `/organisation/${this.currentOrganisation.id}/assistant/${this.assistantId}`;
      api('PUT', url, body, null, 'w')
        .then((response) => {
          if (postActions.length) {
            postActions.forEach((action) => {
              action.assistantId = this.assistantId;
              action.id = randomString(10);
              action.status = StatusTypes.PENDING;
            });
            this.addBackgroundActions(postActions);
            this.$nextTick(() => {
              // update all elements that implement postActions to reset
              this.$eventBus.$emit('resetPostActions');
            });
          }
          this.setNewSchemaValues(response.data);
          // Set new data as base data for changes comparison
          this.assistantsFormSchema = populateEmptySchema(this.assistantsFormSchema, body);
          this.editMessages = {};
          this.updateLocalAssistant({
            member_id: this.assistant.member_id,
            name: data['step-0'].name.data.value.value,
            avatar: data['step-0'].name.data.value.icon,
          });
          setTimeout(() => {
            if (response.data.messages && Array.isArray(response.data.messages)) {
              response.data.messages.forEach((message) => {
                this.showToaster(message.message, null, null, this.toasterTypeMap[message.type]);
              });
            }
            this.clearToggleElements();
            this.clearStepperDataStore();
            this.$eventBus.$emit('setBlockingOverlay', false);
            setTimeout(() => {
              this.updatingAssistant = false;
            }, 1000);
          }, 2000);
        })
        .catch((error) => {
          this.showCreateAssistantError(error);
          this.updatingAssistant = false;
          this.$eventBus.$emit('setBlockingOverlay', false);
        })
        .finally(() => {
          // this.updatingAssistant = false;
        });
    },
    softReset(retryCount = 0) {
      this.loadingSchema = true;
      this.clearBackgroundActions();
      this.refreshPlayground()
        .catch((error) => {
          if (error.message === 'Network Error' && retryCount < 10) {
            setTimeout(() => {
              this.softReset(retryCount + 1);
            }, 1000);
          }
        });
    },
    reloadSchema(retryCount = 0) {
      this.getAssistantScheme(false)
        .then((response) => {
          this.assistantUpdatedCounter++;
          this.setNewSchemaValues(response.data);
          this.editMessages = {};

          // reset file upload specific counters
          localStorage.setItem('aifiles:nCC', 0);
          localStorage.setItem('aifiles:cO', null);
          setTimeout(() => {
            this.clearToggleElements();
            this.clearStepperDataStore();
          }, 2000);
        })
        .catch((error) => {
          if (error.message === 'Network Error' && retryCount < 10) {
            setTimeout(() => {
              this.softReset(retryCount + 1);
            }, 1000);
          }
        });
    },
    // TODO check if needed
    sourcesToFormSchemaChannels(sources) {
      // { number: '+38512345678', location: '🇭🇷 Zagreb', source: 'whatsapp' },
      // { number: 'split@test.com', location: '🇭🇷 Split', source: 'email' },
      // { number: '+38512345678', location: 'Info', source: 'whatsapp' },
      const channels = [];
      Object.entries(sources).forEach(([key, value]) => {
        value.forEach((source) => {
          channels.push({
            source: key,
            number: source.contact,
            location: source.label,
          });
        });
      });
      return channels;
    },
    /** Returns channels object with source as key and array of objects with contact and label as values formated for the widget. */
    proccessSources() {
      const sources = this.formValue.channels;
      const channels = {};
      sources.forEach((source) => {
        if (!channels[source.source]) {
          channels[source.source] = [];
        }
        channels[source.source].push({
          contact: source.number,
          label: source.location,
        });
      });
      return channels;
    },
  },
};
</script>

<style lang="scss" scoped>
.settings__title {
  align-items: center !important;
  height: 54px;

  .flow-state-label {
    font-size: 14px;
    font-weight: 400;
    color: $blackUltralight;
    white-space: unset;
    overflow: unset;
    text-overflow: unset;

    &.live {
      color: $bluePrimary;
    }
  }
}

.full-screen-layout {
  display: flex;
  flex-direction: column;
  // justify-content: center;
  // align-items: center;
  background-color: $white;
  width: 100%;

  .icon-big {
    display: block;
    width: 16px;
    height: 16px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .header {
    height: 54px;
    padding: 15px;

    h1, h1 p {
      font-size: 18px;
      font-weight: bold;
      color: $blackPrimary;

      .green-pill {
        height: 22px;
        padding: 4px 12px 4px 11px;
        border-radius: 11px;
        background-color: #e2fdf9;
        font-size: 12px;
        font-weight: 500;
        color: #00bfa5;
      }
    }

    .btn {
      border-radius: 10px !important;
      padding-left: 13px !important;
      padding-right: 12px !important;
    }
  }

  .footer {
    height: 77px;
    // background: aliceblue;
    bottom: 0;
    right: 0;
    left: 0;
    position: absolute;
    margin: 0 !important;
    padding: 20px;
  }

  #playground-wrapper {
    height: 1px;
    & > div {
      padding: 33px 36px;
    }

    #widget-editor {
      width: 50%;
      flex-shrink: 2;
      padding: 0 0;
      // padding-bottom: 20px;
      // overflow: auto;

      .o-auto {
        padding: 20px 20px;
        margin-bottom: 77px;
        overflow: auto;
      }
    }

    #widget-playground {
      width: 50%;
      min-width: 640px;
    }
  }

  .mask-spinner {
    position: absolute;
    background: $white;
    bottom: 0;
    height: unset;
    z-index: 99999;
    margin: 53px 0 0 0 !important;
    padding-top: 30px;
    // opacity: 0.5; // uncomment to make it transparent for debug
  }

  .body {
    overflow: hidden;
    padding: 0;

    &.no-messages {
      display: flex;
      align-items: center;
      justify-content: center;

      .baloon {
        font-size: 40px;
        margin-bottom: 15px;
      }

      .start-title, .start-title * {
        font-size: 18px;
        font-weight: 500;
        color: $blackPrimary;
        margin-bottom: 7px;
      }

      .start-title * {
        margin-bottom: 0px;
      }

      .start-subtitle {
        font-size: 14px;
        font-weight: 400;
        line-height: 1.2;
        color: $blackUltralight;
      }
    }
  }

  .footer {
    background-color: $white;
    // * {
    //   font-size: 11px;
    //   font-weight: 400;
    //   line-height: 1.53;
    //   color: $blackUltralight;
    // }

    // .info {
    //   padding: 7px 15px 9px;
    // }
  }
}

.action-text {
  color: $blackPrimary !important;
  font-size: 14px !important;
  font-weight: 400 !important;

  span {
    // color: $blackUltralight;
    // font-size: 14px !important;
    // font-weight: 500 !important;
  }
}

#skeleton {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  z-index: 1;
  height: 100%;
}
#iframe-preview {
  width: 100%;
  height: 100%;
  border: none;
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 10;
}

::v-deep {
  .emoji-picker {
    left: unset !important;
    top: unset !important;
  }

  .back-btn {
    &:hover {
      cursor: pointer;
      .sb-icon .icon.mask {
        background-color: $blackPrimary !important;
      }
    }
  }

  #install-web-widget-modal {
    .modal-dialog {
      max-width: 700px !important;
    }

    .modal-body {
      font-size: 16px;
      font-weight: 400;
      line-height: 20px;
      color: $blackPrimary;
      text-align: center;
      padding: 50px 20px;

      h3 {
        padding: 0 25px;
      }

      .tag-markup {
        color: $greenPrimary;
        font-weight: 500;
      }

      .code-section {
        text-align: left;
        color: $blackPrimary;
        font-size: 16px;
        font-weight: 400;
        max-height: 200px;
        padding: 10px;
        border-radius: 10px;
        border: solid 1px $greyBorder;
        background-color: $white;
        overflow-y: auto;
      }

      .copy-me {
        width: fit-content;
        margin: 0 auto;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }
}
</style>

<style lang="scss">
  // .sources-popover {
  //   max-width: 415px;

  //   .popover-body {
  //     padding: 15px !important;
  //   }

  //   h3 {
  //     font-size: 14px;
  //     font-weight: 500;
  //     color: $bluePrimary;
  //   }

  //   a {
  //     border-bottom: 1px dashed $greyBorder;
  //     padding: 10px 0;
  //     color: $blackPrimary;

  //     &:hover {
  //       cursor: pointer;
  //     }

  //     &:last-of-type {
  //       border-bottom: none;
  //       padding: 9px 0 0;
  //     }

  //     p {
  //       line-height: 1 !important;
  //     }

  //     &:hover {
  //       .sb-icon .mask {
  //         background-color: $blackPrimary !important;
  //       }
  //     }
  //   }
  // }
</style>
